/* eslint-disable */
import HttpService from '../HttpService';

const buildQuery = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== null && item !== undefined && item !== '') {
          searchParams.append(key, item);
        }
      });
      return;
    }

    searchParams.append(key, value);
  });

  const query = searchParams.toString().replace(/%2C/gi, ',');
  return query ? `?${query}` : '';
};

export default class ProcedureReportService {
  constructor() {
    this._httpService = new HttpService('/analytics-bff');
  }

  async fetchProcedures(filter, pageable) {
    return this._httpService.post(`/dim-procedure/find-all-by-filters${buildQuery(pageable)}`, filter);
  }

  async fetchCarriers(params) {
    return this._httpService.get(`/carrier/paginated${buildQuery(params)}`, {});
  }

  async fetchEvents(params) {
    return this._httpService.get(`/dim-event${buildQuery(params)}`, {});
  }

  async fetchComplements(params) {
    return this._httpService.get(`/dim-complement${buildQuery(params)}`, {});
  }

  async fetchGroups(params) {
    return this._httpService.get(`/dim-group${buildQuery(params)}`, {});
  }

  async fetchSubGroups(params) {
    return this._httpService.get(`/dim-subgroup${buildQuery(params)}`, {});
  }

  async fetchPredictives(params) {
    return this._httpService.get(`/dim-predictive${buildQuery(params)}`, {});
  }

  async fetchPredictiveClassifications(params) {
    return this._httpService.get(`/dim-predictive-classification${buildQuery(params)}`, {});
  }

  async createEvent(payload) {
    return this._httpService.post('/dim-event', payload);
  }

  async createComplement(payload) {
    return this._httpService.post('/dim-complement', payload);
  }

  async createGroup(payload) {
    return this._httpService.post('/dim-group', payload);
  }

  async createSubGroup(payload) {
    return this._httpService.post('/dim-subgroup', payload);
  }

  async createPredictive(payload) {
    return this._httpService.post('/dim-predictive', payload);
  }

  async createPredictiveClassification(payload) {
    return this._httpService.post('/dim-predictive-classification', payload);
  }

  async export(payload) {
    return this._httpService.post(`/report/dim-procedure${buildQuery(payload)}`, null);
  }

  async fetchReports(params) {
    return this._httpService.get('/report/find-report', params);
  }

  async fetchClassification(payload) {
    return this._httpService.post('/dim-procedure/classification', payload);
  }

  async createProcedure(payload) {
    return this._httpService.post('/dim-procedure', payload);
  }

  async updateProcedure(id, payload) {
    return this._httpService.put(`/dim-procedure/${id}`, payload);
  }

  async updateProceduresBatch(payload) {
    return this._httpService.put('/dim-procedure/batch', payload);
  }

  async fetchProcedureHistory(id) {
    return this._httpService.get(`/dim-procedure/${id}/history`, {});
  }

  async approveClassifications(payload) {
    return this._httpService.post('/dim-procedure/classification/approve', payload);
  }

  async correctClassification(payload) {
    return this._httpService.post('/dim-procedure/classification/correct', payload);
  }
}
